export type MailBrandMode = "gmail-reference" | "asc";

export interface MailBrandConfig {
  mode: MailBrandMode;
  accessibleName: string;
  title: string;
  logoUrl: string;
  faviconUrl: string;
}

export function resolveMailBrandMode(
  explicitMode: string | undefined,
  production: boolean,
): MailBrandMode {
  if (explicitMode === "gmail-reference" || explicitMode === "asc")
    return explicitMode;
  return production ? "asc" : "gmail-reference";
}

export const mailBrandMode = resolveMailBrandMode(
  import.meta.env.VITE_MAIL_BRAND_MODE,
  import.meta.env.PROD,
);

export const mailBrand: MailBrandConfig =
  mailBrandMode === "gmail-reference"
    ? {
        mode: "gmail-reference",
        accessibleName: "Gmail reference",
        title: "Inbox - Gmail reference",
        logoUrl: `${import.meta.env.BASE_URL}gmail-reference-logo.png`,
        faviconUrl: "https://ssl.gstatic.com/ui/v1/icons/mail/rfr/gmail.ico",
      }
    : {
        mode: "asc",
        accessibleName: "ASC Mail",
        title: "Inbox - ASC Mail",
        logoUrl: `${import.meta.env.BASE_URL}ascdnd-logo.png`,
        faviconUrl: `${import.meta.env.BASE_URL}favicon.ico`,
      };

export const authenticatedMailLogo = {
  accessibleName: "Gmail",
  logoUrl: `${import.meta.env.BASE_URL}gmail-reference-logo.png`,
} as const;

export function applyMailBrand() {
  document.title = mailBrand.title;
  let favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!favicon) {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    document.head.append(favicon);
  }
  favicon.href = mailBrand.faviconUrl;
}
